export const STICKER_CDN_LINK =
  "https://api.qr.dev.afea.dev/resources/images/qr-code/stickers/preview";

export const STICKER_LIST = [
  { key: "circle" },
  { key: "simple_bottom", is_mobile: true },
  { key: "opinion", is_mobile: true },
  { key: "simple", is_mobile: true },
  { key: "tooltip_filled", is_mobile: true },
  { key: "tooltip_stroke" },
  { key: "plate" },
  { key: "beer" },
  { key: "cook" },
  { key: "store" },
  { key: "cup" },
  { key: "coffee_bag" },
  { key: "ticket" },
  { key: "download" },
  { key: "gift" },
  { key: "pdf", guest: false },
  { key: "film" },
  { key: "scan_white", is_mobile: true },
  { key: "left_arrow", is_mobile: true },
  { key: "arrows_bottom" },
  { key: "book" },
  { key: "menu2" },
  { key: "opinion2" },
  { key: "hold" },
  { key: "menu1" },
  { key: "rating" },
  { key: "ribbon" },
  { key: "focus" },
  { key: "scan_black" },
  { key: "feedback_black", guest: false },
  { key: "phone" },
  { key: "feedback_white" },
  { key: "2rounded" },
  { key: "hearts", guest: false },
  { key: "arrows_top", is_mobile: true },
  { key: "lock", guest: false },
  { key: "scan_tooltip_bottom", guest: false },
  { key: "service", guest: false },
];
